// extracted by mini-css-extract-plugin
export default {"phone-presentation-edit":"Profile_phone-presentation-edit__kJq1t","limits":"Profile_limits__9jNZ2","ava":"Profile_ava__2I2Ou","hovered":"Profile_hovered__8GsY3"};